import { render, staticRenderFns } from "./ClassificationList.vue?vue&type=template&id=8d0a88c4&"
import script from "./ClassificationList.vue?vue&type=script&lang=ts&"
export * from "./ClassificationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports